export default "__VITE_ASSET__428cf75e__"